import { render, staticRenderFns } from "./Protected.vue?vue&type=template&id=21b9944a&"
import script from "./Protected.vue?vue&type=script&lang=js&"
export * from "./Protected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports